import { changeLocale, getCurrentLocale } from './i18n';

import 'focus-visible';

import '@talend/bootstrap-theme/dist/bootstrap.css';
import { scim, ScimMe, TalendWebappConfiguration, webappConfiguration } from '@talend/context';
import { ServerSettings as semanticServerSettings } from '@talend/data-quality-semantic-ee';
import cmf, { httpMiddleware } from '@talend/react-cmf';

import { ConnectedHome } from './components/Home';
import { getCmfModules } from './modules';
import './polyfills/element-closest';
import { preReducers } from './reducers';
import { mainSaga } from './sagas';
import { CmfModule } from './types/cmf';
import { bootstrapUserAnalytics } from './utils/analytics';
import { getPreloadedState, saveUserPreferencesBeforeUnload } from './utils/local-storage';
import { logout } from './utils/routing';
import createWebsocketMiddleware from './websocket';

semanticServerSettings.setContext('/api/v1/semantic');

// eslint-disable-next-line consistent-return
(async () => {
	// @ts-ignore
	const [config, me]: [TalendWebappConfiguration, ScimMe] = await Promise.all([
		webappConfiguration.get(),
		scim.me.get(),
		scim.account.get(),
	]).catch(logout);

	const userLocale = getCurrentLocale(me);
	changeLocale(userLocale);

	bootstrapUserAnalytics();
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	const configuration: CmfModule = {
		httpMiddleware: httpMiddleware({
			headers: {
				'Accept-Language': userLocale,
			},
		}),
		id: 'tdc',
		preloadedState: getPreloadedState(),
		middlewares: [createWebsocketMiddleware()],
		modules: getCmfModules(config),
		preReducer: preReducers,
		RootComponent: () => <ConnectedHome />,
		saga: mainSaga,
		settingsURL: `/settings.${userLocale}.json`,
		storeCallback: (store: any) => {
			saveUserPreferencesBeforeUnload(store);
		},
	};

	cmf.bootstrap(configuration);
})();
